module.exports = __webpack_public_path__ + "static/img/sa.c36d1991.svg";